export { default as webToken } from './webToken'; // token 相关接口
export { default as company } from './company'; // 公司 相关接口
export { default as appStore } from './appStore'; // app应用 相关接口
export { default as message } from './message'; // 消息中心 相关接口
export { default as platform } from './platform'; // 平台 相关接口
export { default as authorizeByCode } from './authorizeByCode'; //  
export { default as bindContinueAuthorize } from './bindContinueAuthorize'; //
export { default as account3rdList } from './account3rdList'; //
export { default as account3rdUnbind } from './account3rdUnbind'; //
export { default as oauth2WebBindOnly } from './oauth2WebBindOnly'; //


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/api/index.ts